/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetDeviceControlPointIdMapRequest = {
  agentId: string;
};

/** @internal */
export const GetDeviceControlPointIdMapRequest$inboundSchema: z.ZodType<
  GetDeviceControlPointIdMapRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetDeviceControlPointIdMapRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetDeviceControlPointIdMapRequest$outboundSchema: z.ZodType<
  GetDeviceControlPointIdMapRequest$Outbound,
  z.ZodTypeDef,
  GetDeviceControlPointIdMapRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getDeviceControlPointIdMapRequestToJSON(
  getDeviceControlPointIdMapRequest: GetDeviceControlPointIdMapRequest,
): string {
  return JSON.stringify(
    GetDeviceControlPointIdMapRequest$outboundSchema.parse(
      getDeviceControlPointIdMapRequest,
    ),
  );
}
export function getDeviceControlPointIdMapRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetDeviceControlPointIdMapRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDeviceControlPointIdMapRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDeviceControlPointIdMapRequest' from JSON`,
  );
}
